var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1130)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1130",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 35,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.5H52V52.5H17V17.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.998 30.3174L36.5323 29.7842L37.9306 28.389C38.6522 27.6691 38.6522 26.4899 37.9306 25.7699C37.209 25.0499 36.0272 25.0499 35.3056 25.7699L33.373 27.6983",
    stroke: "#F3922F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9882 34.1181C44.3564 33.4876 43.3208 33.4876 42.689 34.1181L40.2336 36.5699C39.6018 37.2004 39.6018 38.2317 40.2336 38.8621C40.8655 39.4926 41.8992 39.4926 42.5311 38.8621L44.9882 36.4103C45.6202 35.7799 45.6202 34.7486 44.9882 34.1181Z",
    stroke: "#F3922F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3095 31.2531C40.0637 31.4983 40.5688 30.9943 40.5766 30.9866C41.2767 30.2646 41.269 29.1029 40.5552 28.3888C39.8336 27.6688 38.6518 27.6688 37.9302 28.3888L36.9629 29.3539",
    stroke: "#F3922F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.023 46.595C39.9859 45.7135 40.1536 44.8223 40.5301 44.0071L32.0467 35.5406M41.8035 39.2806L43.5353 41.0084C45.6064 40.0589 48.1514 40.4325 49.852 42.1293C51.2094 43.4836 51.7223 45.375 51.3888 47.134C51.0396 48.9806 50.0646 47.5835 49.8656 47.3851L47.4844 45.0092C46.6517 44.1783 45.3119 44.1433 44.4363 44.906C43.6718 45.7797 43.7069 47.1165 44.5396 47.9475L46.9208 50.3234C47.1198 50.5218 48.52 51.4948 46.6693 51.8431C44.9063 52.1758 43.0107 51.664 41.6534 50.3097C41.2301 49.8855 40.8889 49.4107 40.6295 48.9048M30.5957 28.0996L28.47 25.9766C29.4217 23.9101 29.0472 21.3708 27.3466 19.674C25.9893 18.3197 24.0938 17.8079 22.3307 18.1406C20.48 18.4889 21.8803 19.4619 22.0792 19.6603L24.4604 22.0362C25.2931 22.8672 25.3282 24.204 24.5638 25.0776C23.6881 25.8404 22.3483 25.8054 21.5156 24.9745L19.1344 22.5986C18.9355 22.4001 17.9604 21.003 17.6112 22.8497C17.2778 24.6087 17.7907 26.5001 19.1481 27.8544C20.8486 29.5512 23.3936 29.9248 25.4648 28.9753L27.7153 31.2207",
    stroke: "#F3922F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8592 44.427L29.8001 47.3613C30.2546 47.8148 30.2546 48.5561 29.8001 49.0096L27.1849 51.619C26.7305 52.0723 25.9875 52.0723 25.5331 51.619L18.3115 44.4134C17.8571 43.96 17.8571 43.2186 18.3115 42.7652L20.9267 40.1558C21.3811 39.7024 22.1241 39.7024 22.5786 40.1558L25.1645 42.7361",
    stroke: "#F3922F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7998 47.3613L33.2829 43.886C34.5876 42.5842 34.841 42.8644 36.3817 43.0844C37.0721 43.1835 38.0569 42.8158 38.8487 42.3293",
    stroke: "#F3922F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6892 31.4989C41.9676 30.779 40.7858 30.779 40.0642 31.4989L38.1393 33.4195C37.4158 34.1414 37.4158 35.3187 38.1393 36.0386C38.8609 36.7606 40.0427 36.7606 40.7643 36.0386L42.6892 34.1181C43.4127 33.3981 43.4127 32.2189 42.6892 31.4989Z",
    stroke: "#F3922F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3767 33.1842C38.4294 32.6725 37.5829 31.8999 36.7131 31.0321L32.8888 27.2162C32.5027 26.831 31.8669 26.831 31.4789 27.2182L28.3214 30.3686C27.6038 31.0846 27.2819 32.1374 27.3385 33.083C27.4263 34.5308 26.7515 35.9941 24.7506 37.9886L22.5781 40.1562M32.0366 31.6042C32.0697 31.6392 33.3627 32.9274 33.3959 32.9605C34.4197 33.9489 36.4849 34.8012 37.8169 33.8517",
    stroke: "#F3922F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.037 31.604C33.1778 32.7423 32.8619 34.9022 31.333 36.4277",
    stroke: "#F3922F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(17 17.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.54ed42f341f85c215e84942965e2878d.svg";
export { ForwardRef as ReactComponent };